import { request } from "../../utils/config"
import { loginVariables, login_login } from "./types/login"
import { registerVariables, register } from "./types/register"

type Login = (data: loginVariables) => Promise<login_login | null>
type Register = (data: registerVariables) => Promise<register>

export const LOGIN: Login = async (data) => {
  const response = await request({
    url: `AccountAPI/Login?Email=${encodeURIComponent(data?.email || "")}&Password=${encodeURIComponent(data?.password || "")}`,
    method: "POST",
  })
  return response.data
}

export const REGISTER: Register = async (data) => {
  const response = await request({
    url: "AccountAPI/Register",
    method: "POST",
    data: data,
  })
  return response.data
}
